import { Component, OnInit, inject } from "@angular/core";
import { InitService } from "src/app/shared/services/init.service";
import { LoadingService } from "../../loading/loading.service";
import { OptionService } from "../../option/option.service";
import { ReceptionService } from "../reception.service";
import { PRODUCTS_LINK } from "src/app/shared/consts/external-links";
import { DialogContainerComponent } from "@components/dialog-container/dialog-container.component";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { TextButtonComponent } from "../../../shared/components/text-button/text-button.component";
import { TranslocoPipe } from "@jsverse/transloco";
import { MatDialog } from "@angular/material/dialog";
import { ContactPageComponent } from "../contact-page/contact-page.component";

@Component({
  selector: "app-landing-page-dialog",
  templateUrl: "./landing-page-dialog.component.html",
  styleUrls: ["./landing-page-dialog.component.scss"],
  imports: [DialogContainerComponent, MatFormField, MatLabel, MatInput, MatButton, TextButtonComponent, TranslocoPipe]
})
export class LandingPageDialogComponent implements OnInit {
  initService = inject(InitService);
  optionService = inject(OptionService);
  receptionService = inject(ReceptionService);
  private readonly loadingService = inject(LoadingService);
  private readonly dialog = inject(MatDialog);

  ngOnInit() {
    this.loadingService.hide();
  }

  goToContactForm() {
    this.dialog.open(ContactPageComponent);
  }

  goToVideoExamples() {
    window.open(PRODUCTS_LINK, "_blank");
  }
}
